import React from 'react';
import ContactForm from '../forms/ContactForm';

const LeadSection = () => {
  return (
    <section className="section-padding bg-gradient-to-br from-[#111111] via-[#0B0B0B] to-[#111111]">
      <div className="container-luxury">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className="heading-luxury mb-6">
              Готови за <span className="gradient-text">информирано решение</span>?
            </h2>
            <p className="text-lg text-[#A9A9A9] leading-relaxed max-w-2xl mx-auto">
              Свържете се с нас за безплатна първоначална консултация или оценка на вашия имот
            </p>
          </div>

          {/* Form Card */}
          <div className="bg-[#0B0B0B] border border-[#D4AF37]/20 rounded-2xl p-8 lg:p-12 shadow-xl shadow-[#D4AF37]/5">
            <ContactForm formType="contact" />
          </div>

          {/* Additional Info */}
          <div className="mt-8 text-center">
            <p className="text-sm text-[#A9A9A9]">
              Или се свържете директно:{' '}
              <a href="mailto:zaharii.stoyanov@deusestate.com" className="text-[#D4AF37] hover:text-[#F3D98B] transition-colors duration-300">
                zaharii.stoyanov@deusestate.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeadSection;
